import { createTheme, Theme } from "@mui/material";

export const createAppTheme = (mode: 'light' | 'dark'): Theme => {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#e5e8d9',
      },
      secondary: {
        // main: '#ffffff',
        main: '#323232',
        // dark: '#191b1e'
      },
      background: {
        default: mode === 'dark' ? '#191b1e' : '#ffffff',
        paper: mode === 'dark' ? '#121212' : '#f5f5f5',
      },
    },
    typography: {
      fontFamily: [
        'Russo One'
      ].join(",")
    }
  });
};